import React from "react";
import { Outlet } from "react-router-dom";
import { NotFoundPage } from "pages/NotFoundPage";
import type { RbacPolicyProps } from "./RbacPolicies";
import { useRbacContext } from "./RbacProvider";

type ProtectedRouteProps = {
  policies: RbacPolicyProps;
  element?: React.ReactNode;
};

export function ProtectedRoute({ policies, element }: ProtectedRouteProps) {
  const { isAuthorized } = useRbacContext();
  return isAuthorized(policies) ? <>{element || <Outlet />}</> : <NotFoundPage />;
}
